import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--receipts--expense"
export default class extends Controller {
  static targets = [
    "form",
    "button",
    "buttonPlusIcon",
    "buttonMinusIcon",
    "action",
    "amountEuro",
    "amountCent",
    "viewTemplate",
    "viewExpenseContainer",
    "formExpenseTemplate",
    "formExpenseContainer",
    "expensesLabel",
    "expense"
  ]

  toggle() {
    this.formTarget.classList.toggle("hidden")
    this.buttonPlusIconTarget.classList.toggle("hidden")
    this.buttonMinusIconTarget.classList.toggle("hidden")
  }

  expensesLabel() {
    if (!this.hasExpensesLabelTarget) { return }

    if (this.expenseTargets.length === 0) {
      this.expensesLabelTarget.classList.add("hidden")
    } else {
      this.expensesLabelTarget.classList.remove("hidden")
    }
  }

  addExpense() {
    if (this.actionTarget.value === "" || this.amountEuroTarget.value === "" || this.amountCentTarget.value === "" || this.amountCentTarget.value.toString().length < 2) { return }

    let id = new Date().getTime()
    let action = this.actionTarget.value
    let amount = this.amountEuroTarget.value + "," + this.amountCentTarget.value + " €"
    let amountCents = this.amountEuroTarget.value + this.amountCentTarget.value

    this.createViewTemplate(id, action, amount)
    this.createFormTemplate(id, action, amountCents)

    this.actionTarget.value = ""
    this.amountEuroTarget.value = ""
    this.amountCentTarget.value = ""

    this.expensesLabel()
  }

  removeExpense(event) {
    let items = document.querySelectorAll(`[data-id='${event.currentTarget.dataset.id}']`)

    items.forEach(item => { item.remove() })

    this.expensesLabel()
  }

  createViewTemplate(id, action, amount) {
    let template = this.viewTemplateTarget.content.cloneNode(true).firstElementChild

    template.dataset.id = id
    template.dataset.amount = amount

    template.querySelector("[data-expense-label='true']").textContent = action
    template.querySelector("[data-expense-amount='true']").textContent = amount

    this.viewExpenseContainerTarget.appendChild(template)
  }

  createFormTemplate(id, action, amountCents) {
    let template = this.formExpenseTemplateTarget.cloneNode(true)

    template.innerHTML = template.innerHTML.replaceAll("NEW_RECORD", id)
    template = template.content.firstElementChild

    template.dataset.id = id
    template.setAttribute("data-admins--receipts--calculator-target", "expense")
    template.querySelector("input[data-field='action']").value = action
    template.querySelector("input[data-field='amount']").value = amountCents

    this.formExpenseContainerTarget.appendChild(template)
  }
}
